import React, { useState } from 'react';
import { configService } from '../services/configService';

function ComingSoonModal({ 
  isOpen, 
  onClose, 
  featureName
}) {
  const [loading, setLoading] = useState(false);

  if (!isOpen) return null;

  const handleOk = async () => {
    setLoading(true);
    
    try {
      await configService.recordFeatureEngagement(
        'dashboard_feature',
        featureName.toLowerCase().replace(/\s+/g, '_'),
        featureName,
        'interested',
        { page: 'dashboard', location: 'quick_actions' }
      );
    } catch (error) {
      console.error('Failed to record engagement:', error);
    } finally {
      setLoading(false);
      onClose();
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-8 rounded-2xl max-w-md w-full mx-4 shadow-xl">
        <h2 className="text-2xl font-bold text-gray-900 mb-4">Coming Soon!</h2>
        <p className="text-gray-600 mb-6">
          <strong>{featureName}</strong> is coming soon! We're working hard to bring you this feature.
        </p>
        <button 
          className="w-full px-6 py-3 bg-blue-500 hover:bg-blue-600 text-white rounded-xl font-semibold"
          onClick={handleOk}
          disabled={loading}
        >
          {loading ? 'Recording...' : 'OK'}
        </button>
      </div>
    </div>
  );
}

export default ComingSoonModal;